import { createContext, useContext } from 'react'

export const TokenContext = createContext()

export function useTokenContext() {
  return useContext(TokenContext)
}

